<template>
  <q-btn
      v-bind="$attrs"
      class="btn btn__common btn__common--warning"
      no-caps
      unelevated
  >
    <slot />
  </q-btn>
</template>
